module.exports = __webpack_public_path__ + "static/img/3_2.ce972b17.jpg";